import config from '../config';
import http from '@/utils/http';
import { Font } from '@/types/api/fonts';

export async function apiGetFonts(): Promise<Font[]> {
  const response = await http.get<Font[]>(`${config.apiUrl}userapi/fonts/`);
  return response.data;
}
